module.exports = __webpack_public_path__ + "img/05.d048e790.png";